export enum ChangePasswordFieldType {
  CurrentPassword = 'currentPassword',
  NewPassword = 'newPassword',
  ConfirmPassword = 'confirmPassword',
}